import BaseModel from '../BaseModel';

export default class VacancySettings extends BaseModel {
  static entity = 'vacancySettings';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      vacancyId: this.attr(null),
      autoInvitation: this.boolean(false),
      notificationMethod: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      async update(id, payload) {
        return this.put(`vacancies/${id}/settings`, payload);
      },
    },
  }
}
